import { StoryTranslationType } from "../../features/story.types";

export const story: StoryTranslationType = {
  success: {
    charactersSaved: "Shranjeni Lik",
    charactersAddedToLibrary: "Lik Dodan v Knjižnico"
  },
  storySetup: {
    titles: {
      new: "Ustvari Novo Zgodbo",
      edit: "Uredi Zgodbo",
      continue: "Nadaljuj Zgodbo"
    },
    basicInfo: {
      storyTitle: "Naslov zgodbe",
      titlePlaceholder: "Vnesite naslov zgodbe",
      silverLining: "Bistvo zgodbe",
      descriptionPlaceholder: "O čem pravzaprav govori vaša zgodba? To bo pomagalo voditi pripoved.",
      genre: "Žanr",
      selectGenre: "Izberite žanr",
      environment: "Okolje",
      selectEnvironment: "Izberite okolje",      
      theme: "Teme",
      storyLength: "Dolžina zgodbe",
      storyLengthWithNumberOfPages: "Dolžina zgodbe (število strani)",
      selectLength: "Izberite dolžino",
      aiSuggest: "AI predlog",
      missingValues: "Manjkajoče vrednosti",
      fillRequired: "Prosimo, izpolnite vsa obvezna polja",
      titleGenerated: "Naslov ustvarjen",
      generationError: "Napaka pri ustvarjanju",
      tryAgain: "Poskusite znova",
      addCustomGenre: "Dodaj svoj žanr...",
      addCustomEnvironment: "Dodaj svoje okolje...",
      addCustomTheme: "Dodaj svojo temo...",
      autoGenerate: "Samodejno generiraj",
      formDataGenerated: "Podatki obrazca ustvarjeni",
      dataUpdated: "Podatki posodobljeni",
      formDataEnhanced: "Podatki obrazca izboljšani",
      noEnhancementsNeeded: "Ni potrebnih izboljšav",
      formDataUpToDate: "Podatki obrazca so posodobljeni",
      needSomeInfo: "Potrebujemo nekaj informacij, da začnemo"
    },
    genres: {
      fantasy: "Fantazija",
      scienceFiction: "Znanstvena fantastika",
      mystery: "Skrivnost",
      romance: "Romanca",
      adventure: "Pustolovščina",
      horror: "Grozljivka",
      historicalFiction: "Zgodovinska fikcija",
      contemporary: "Sodobno",
      superhero: "Superjunak",
      kidsStory: "Otroška zgodba",
      thriller: "Triler"
    },
    environments: {
      urbanCity: "Urbano mesto",
      medievalCastle: "Srednjeveški grad",
      spaceStation: "Vesoljska postaja",
      forest: "Gozd",
      desert: "Puščava",
      ocean: "Ocean",
      mountain: "Gora",
      smallTown: "Majhno mesto",
      futuristicMetropolis: "Futuristična metropola",
      underwaterKingdom: "Podvodno kraljestvo",
      hauntedMansion: "Strašljiva graščina",
      mountainCavern: "Gorska jama",
      dragonLair: "Zmajevo gnezdo",
      researchLaboratory: "Raziskovalni laboratorij",
      futureCommunications: "Futuristične komunikacije",
      magicalLibrary: "Magična knjižnica",
      rainyNight: "Deževna noč",
      ancientTemple: "Starodavni tempelj"
    },
    storyLengths: {
      short: "Kratka",
      medium: "Srednja",
      long: "Dolga",
      natural: "Naravna"
    },
    characters: {
      name: "Ime",
      description: "Opis",
      title: "Liki",
      browseCharacters: "Prebrskaj like",
      makePublic: "Naredi lik javen"
    },
    themeSection: {
      title: "Teme"
    },
    themeOptions: {
      friendship: "Prijateljstvo",
      love: "Ljubezen",
      betrayal: "Izdaja",
      redemption: "Odkupitev",
      growth: "Rast",
      power: "Moč",
      justice: "Pravičnost",
      family: "Družina",
      courageBravery: "Pogum",
      magicMythology: "Magija in mitologija",
      survival: "Preživetje",
      warConflict: "Vojna in konflikt",
      freedomRebellion: "Svoboda in upor",
      violenceRevenge: "Nasilje in maščevanje",
      passionEroticism: "Strast in erotika",
      quest: "Iskanje",
      ancientWisdom: "Starodavna modrost",
      timeTravel: "Potovanje skozi čas",
      technology: "Tehnologija",
      paradox: "Paradoks",
      knowledge: "Znanje",
      magic: "Magija",
      discovery: "Odkritje",
      identity: "Identiteta",
      sacrifice: "Žrtvovanje",
      transformation: "Preobrazba"
    },
    buttons: {
      create: "Ustvari zgodbo",
      update: "Posodobi zgodbo"
    },
    character: {
      name: "Ime Lika",
      namePlaceholder: "Vnesite ime lika",
      role: "Vloga Lika",
      selectRole: "Izberite vlogo lika",
      description: "Opis Lika",
      descriptionPlaceholder: "Vnesite opis lika",
      create: "Ustvari Lik",
      update: "Posodobi Lik",
      roles: {
        protagonist: "Protagonist",
        antagonist: "Antagonist",
        deuteragonist: "Stranski lik",
        mentor: "Mentor",
        comic_relief: "Komični lik",
        mysterious: "Skrivnostna oseba",
        love_interest: "Ljubezenski interes",
        anti_hero: "Anti-junak",
        sidekick: "Pomočnik",
        shapeshifter: "Spreminjač oblike",
        guardian: "Varuh",
        catalyst: "Katalizator"
      }
    },
    success: {
      title: "Nastavitev Zgodbe Zaključena",
      description: "Vaša zgodba je bila uspešno ustvarjena in je pripravljena za vašo ustvarjalno pot."
    },
    failure: {
      title: "Napaka",
      description: "Prišlo je do napake pri ustvarjanju zgodbe. Poskusite znova.",
    },
  },
  story: {
    parts: "Deli",
    part: "Del",
    continueStory: "Nadaljuj zgodbo",
    print: "Natisni",
    generatingSummary: "Ustvarjanje povzetka",
    generatingContinuation: "Ustvarjanje nadaljevanja",
    pleaseWait: "Prosimo, počakajte...",
    backToDashboard: "Nazaj na nadzorno ploščo",
    extractCharacters: "Izvleci like",
    foundCharacters: "Najdeni liki",
    addSelectedCharacters: "Dodaj izbrane like",
    share: "Deli",
    viewEntire: "Ogled celotne zgodbe",
    viewPaginated: "Ogled po straneh",
    tooltips: {
      upgradeToContinue: "Nadgradite za nadaljevanje zgodb",
      upgradeToShare: "Nadgradite za deljenje zgodb",
      upgradeToExtract: "Nadgradite za izvlečenje likov"
    },
    ratings: {
      submitted: "Ocena poslana",
      thankYou: "Hvala za oceno te zgodbe!",
      error: "Napaka",
      failedToSubmit: "Ocene ni bilo mogoče poslati"
    },
    sharing: {
      dialogTitle: "Deli svojo zgodbo",
      dialogDescription: "Izberi, kje želiš deliti svojo zgodbo",
      privacy: "Zasebnost zgodbe",
      privacyLevels: {
        private: "Zasebno",
        public: "Javno",
        friends: "Samo prijatelji"
      },
      platform: "Platforma",
      selectPlatform: "Izberi platformo",
      customMessage: "Prilagojeno sporočilo",
      customMessagePlaceholder: "Dodaj sporočilo k svoji objavi...",
      shareButton: "Deli zgodbo",
      successTitle: "Zgodba uspešno deljena",
      successMessage: "Tvoja zgodba je bila deljena na {{platform}}",
      authRequired: "Potrebna je avtentikacija",
      authMessage: "Prosimo, prijavite se za deljenje zgodb."
    },
    upgrade: {
      title: "Potrebna je nadgradnja",
      continueDescription: "Nadgradite svoj račun za ustvarjanje zaporedij zgodb.",
      continueFeature: "Ustvarjajte zaporedja zgodb s premium naročnino",
      shareDescription: "Nadgradite svoj račun za deljenje zgodb.",
      shareFeature: "Delite zgodbe z osnovno naročnino",
      extractDescription: "Nadgradite svoj račun za izvlečenje likov.",
      extractFeature: "Izvlecite like s premium naročnino",
      upgradeButton: "Nadgradi zdaj"
    }
  },
  storyEditor: {
    navigation: {
      previousPage: "Prejšnja stran",
      continue: "Nadaljuj",
      returnToDashboard: "Nazaj na nadzorno ploščo",
      page: "Stran",
      of: "od",
      remainingPages: "Preostale strani",
    },
    input: {
      customResponse: "Prilagojen odgovor"
    },
    choices: {
      yourChoice: "Vaša izbira"
    },
    completedStory: {
      title: "Zgodba zaključena",
      description: "Vaša zgodba je dosegla svoj zaključek!",
    },
  },
  imageGeneration:{
    ready: "Pripravljeno",
    imageReady: "Slika pripravljena",
    insufficientCredits: "Premalo kreditov",
    needMoreCredits: "Potrebujete več kreditov",
    failed: "Neuspešno",
    processing: "Obdelava",
    pleaseWait: "Prosimo, počakajte",
    unexpectedError: "Nepričakovana napaka",
    generateImage: "Ustvari sliko",
    costsCredits: "Stane kredite",
    generatingImage: "Ustvarjanje slike",
    credits: "kreditov",
    creditsLabel: "kreditov",
    selectImage: "Izberi sliko",
    selectImageDescription: "Izberite sliko, ki jo želite uporabiti za ta del zgodbe",
    selectPreferred: "Izberi želeno sliko",
    contentNotFound: "Vsebina ni bila najdena",
    saved: "Slika shranjena",
    imageSaved: "Slika shranjena",
    partialSuccess: "Delni uspeh",
    someImagesFailed: "Nekatere slike niso bile uspešno ustvarjene",
  },
  audioGeneration: {
    insufficientCredits: "Premalo kreditov",
    generateAudio: "Ustvari zvok",
    generatingAudio: "Ustvarjanje zvoka",
    pleaseWait: "Prosimo, počakajte",
    failed: "Neuspešno",
    success: "Uspešno",
    audioReady: "Zvok pripravljen",
    audioAvailable: "Zvok na voljo"
  },
  storyRewrite:{
    rewritesLeft: "Preostale prenove",
    rewriteStory: "Prenovite zgodbo",
    rewriteComplete: "Prenova zgodbe zaključena",
    refreshingContent: "Osveževanje vsebine",
    refreshError: "Napaka osveževanja",
    refreshErrorMessage: "Prišlo je do nepričakovane napake pri osveževanju zgodbe. Poskusite znova.",
    noRewritesLeft: "Ni več prenov",
    tryPageRefresh: "Poskusite osvežiti stran",
  },
  loadingMessages: {
    craftingTheNextChapter: "Oblikovanje naslednjega poglavja",
    weavingThePlotTwists: "Prepletanje zapletov",
    yourAdventureIsAboutToUnfold: "Vaša pustolovščina se bo kmalu razkrila",
    developingTheCharacters: "Razvijanje likov",
    imaginingNewPossibilities: "Predstavljanje novih možnosti",
  },
};
